import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_SALARY = 0;
const DEFAULT_MAX_SALARY = 100000;

export const salaryDescriptor = defineFilter({
  definition: {
    id: FilterId.SALARY,
    name: 'Salary',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_SALARY,
    max: DEFAULT_MAX_SALARY,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_SALARY, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(DEFAULT_MIN_SALARY, DEFAULT_MAX_SALARY),
});
